import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import Select from '../Select';

const values = ['twoweeks', 'fourweeks'];

const ContractTerminationTypeSelect = ({ name, label, disabled, fullWidth, allowEmpty }) => {
    const { t } = useTranslation();
    const options = useMemo(
        () =>
            values.map((value) => ({
                value,
                label: t(`contract.terminationType.${value}`),
            })),
        [t]
    );
    return (
        <Select
            name={name}
            label={label}
            options={options}
            fullWidth={fullWidth}
            disabled={disabled}
        />
    );
};

ContractTerminationTypeSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    allowEmpty: PropTypes.bool,
};

ContractTerminationTypeSelect.defaultProps = {
    label: null,
    disabled: false,
    fullWidth: true,
};

export default ContractTerminationTypeSelect;
